import {Component, EventEmitter, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {EmailSmsPreviewModalComponent} from "../../components/email-sms-preview-modal/email-sms-preview-modal.component";
import {EmailSmsPlaceholderModalComponent} from "../../components/email-sms-placeholder-modal/email-sms-placeholder-modal.component";
import {OrganisationService} from "../../services/organisation/organisation.service";
import {LANG_OPTIONS} from "../../lang.constants";
import {ActivatedRoute} from '@angular/router';
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {WarningModalContentComponent} from "../../lib/warning-modal/warning-modal.component";
import { setPageDirtyFlag } from 'src/app/shared/page-dirty-flag';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-email-sms-template',
  templateUrl: './email-sms-template.component.pug',
  styleUrls: ['./email-sms-template.component.scss'],
  standalone: false
})
export class EmailSmsTemplateComponent implements OnInit, OnChanges, OnDestroy {

  selectedTemplate = '';
  selectedTemplateValue = '';
  alertTypeError = 'danger';
  subjectLine = '';
  bsModalRef!: BsModalRef;
  templates: any[] = [];
  dbResponse: any[] = [];
  templateVariables: any[] = [];
  brandName = '';
  defaultTemplate = false;
  templatesModified = false;
  org: any;
  subjectLineCharLimit = 998;
  smsCharLimit = 1600;
  languages: any[] = [];
  orgLanguages = '';
  resourceType = '';
  languageTemplateToRevert = '';
  messages: any[] = [];
  managerTemplate = false;
  managerTemplateKeys = ['verification_request', 'verification_request_reminder']
  templateOptions = [
    {
      'key': 'exit_request',
      'value': $localize `Exit request: Delivered to the employee when an exit request is sent.`},
    {
      'key': 'exit_request_reminder',
      'value': $localize `Exit request reminder: Delivered to the employee at regular intervals following the initial exit request.`
    },
    {
      'key': 'verification_request',
      'value': $localize `Verification request: Delivered to the manager when an employee chooses to request manager verification.`
    },
    {
      'key': 'verification_request_reminder',
      'value': $localize `Verification request reminder: Delivered to the manager at regular intervals following the initial verification request.`
    }
  ];
  errorMap = new Map([
        ["placeholders", new Map<any, any>([["invalid", {
          'message': $localize`Ensure all required placeholders are included in your email & SMS to send your request. `,
          'type': 'danger'
        }
        ]])]
      ]);
  brand_name;
  buttonContent = $localize `View`;
  templateType = 'exit';
  public previewClick: EventEmitter<any> = new EventEmitter();
  public viewPlaceholderClick: EventEmitter<any> = new EventEmitter();

  constructor(private route: ActivatedRoute,
              private modalService: BsModalService,
              private organisationService: OrganisationService,
              private alertList: AlertBannerService,
              private permission: PermissionsService) {
  }

  ngOnInit(): void {
    if(this.templateType=='pulse') {
      this.templateOptions = [
        {
          'key': 'pulse_request',
          'value': $localize `Initial request: Email/SMS delivered to the employee when a request is sent.`},
        {
          'key': 'pulse_request_reminder',
          'value': $localize `Reminder: Email/SMS delivered to the employee at set intervals following the initial request.`
        }
      ];
    }
    setPageDirtyFlag(false);
    let orgBrandName = this.brand_name;
    this.getOrgDetails(orgBrandName)
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  ngOnDestroy() {
    setPageDirtyFlag(false);
  }

  isDirty(): boolean {
    return this.templatesModified;
  }

  closeModal() {
    this.modalService.hide();
  }

  onSelectChange(value) {
    if(this.templatesModified) {
      this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
        class: 'modal-dialog-centered',
        initialState: {
          "title": $localize`Change template?`,
          "message": $localize`Any changes you have made will be lost.\n\nAre you sure you want to continue?`
        }
      });
      this.bsModalRef.content.selection.subscribe(res => {
        if (res === true) {
          this.changeTemplate(value)
        }
      })
    } else {
        this.changeTemplate(value)
    }
  }

  changeTemplate(value) {
    this.selectedTemplate = value['key'];
    this.selectedTemplateValue = value['value'];
    this.managerTemplate = this.managerTemplateKeys.includes(value['key']);
    this.reset()
    this.getEmailTemplates();
  }

  getOrgDetails(brandName) {
    this.organisationService.getOrganisationByBrandName(brandName).subscribe(res => {
      this.brandName = res.brand_name;
      this.org = res;
    }, error => {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })
  }

  templateLanguage() {
    this.templates.forEach((val, index) => {
      let displayLanguage = LANG_OPTIONS.get(val.language)
      this.languages.push(displayLanguage)
      if (index > 0) {
        this.orgLanguages += $localize` and ` + displayLanguage;
        return;
      }
      this.orgLanguages += displayLanguage;
    })
  }

  validate() {
    this.templates.forEach(value => {
      value['send_sms'] = !this.managerTemplate;
    })
    this.organisationService.checkEmailSmsPlaceholders(this.templates, this.selectedTemplate).subscribe((data: any) => {
      this.showPreview()
      },
  (error: any) => {
      console.log(error);
      for (const [key, value] of Object.entries(error.error['data']['errors'])) {
        let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
        let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
        this.setMessages([{
        'type': 'danger',
        'message': message['message']
        }]);
      }
    })
  }

  showPreview() {
    let initialState = {
      'templates': this.templates,
      'orgLogo': this.org['logo'],
      'color': this.org['color'],
      'secondary_color': this.org['secondary_color'],
      "managerTemplate": this.managerTemplate,
      'selectedTemplate': this.selectedTemplate,
      'selectedTemplateValue': this.selectedTemplateValue,
      'languages': this.languages,
      'templateVariables': this.templateVariables,
      'templateType': this.templateType,
      'orgLanguages': this.orgLanguages,
      'orgUid': this.org['uid']};
    this.previewClick.emit(initialState);

  }

  showPlaceholderModal() {
    let initialState = {
      'variables': this.templateVariables,
      'showSMS': !this.managerTemplate,
      'templates': this.templates,
      'orgLogo': this.org['logo'],
      'color': this.org['color'],
      'secondary_color': this.org['secondary_color'],
      "managerTemplate": this.managerTemplate,
      'selectedTemplate': this.selectedTemplate,
      'selectedTemplateValue': this.selectedTemplateValue,
      'languages': this.languages,
      'templateVariables': this.templateVariables,
      'templateType': this.templateType,
      'orgLanguages': this.orgLanguages,
      'orgUid': this.org['uid']
    };
    this.viewPlaceholderClick.emit(initialState);
  }

  getEmailTemplates() {
    this.organisationService.getTemplates(this.defaultTemplate, this.selectedTemplate, this.resourceType).subscribe(response => {
      this.dbResponse = response.data.templates;
      this.templates = this.dbResponse;
      this.templateVariables = response.data.variables;
      this.reset();
      }, error => {
        this.templates = [];
        this.languages = [];
        this.orgLanguages = '';
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  getEmailTemplateToRevert() {
    this.organisationService.getTemplate(this.defaultTemplate, this.languageTemplateToRevert, this.selectedTemplate, this.resourceType).subscribe(response => {
      this.dbResponse = response.data;
      this.dbResponse.forEach((val, index) => {
        if (val.language === this.languageTemplateToRevert) {
          this.templates[index][this.resourceType] = val[this.resourceType];
        }
      })
      this.resetMessages();
      this.reset();
      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  setCharLimits() {
    if (this.templates) {
      if (this.templates.length > 1) {
        this.smsCharLimit = (this.smsCharLimit / this.templates.length) - 3;
        this.subjectLineCharLimit = (this.subjectLineCharLimit / this.templates.length) - 3;
      }
    }
  }

  reset() {
    this.defaultTemplate = false;
    this.templatesModified = false;
    this.resourceType = '';
    this.subjectLineCharLimit = 998;
    this.smsCharLimit = 1600;
    this.languages = [];
    this.orgLanguages = '';
    this.setCharLimits();
    this.templateLanguage();
    setPageDirtyFlag(false);
  }

  revertToDefault(type, language) {
    let initialState = {
      "title": $localize`Revert to system default? `,
      "message": $localize`By reverting to the system default, all changes will be lost.\n\nAre you sure you want to continue?  `
    };
    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered max-width-400', initialState
    });
    this.bsModalRef.content.selection.subscribe(res => {
      if (res === true) {
        this.languageTemplateToRevert = language;
        this.defaultTemplate = true;
        this.resourceType = type;
        this.getEmailTemplateToRevert();
      }
    })
  }

  setMessages(newMessages) {
    this.messages = this.messages.concat(newMessages);
  }

  resetMessages() {
    this.templatesModified = true;
    setPageDirtyFlag(true);
    this.messages = [];
  }

  saveTemplate() {
    this.messages = [];
    this.organisationService.updateOrganisationTemplate(this.selectedTemplate, this.templates).subscribe(response => {
      this.templatesModified = false;
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Success! Template was saved successfully.`,
        keepOnRouteChange: true
      }]);
      }, error => {
        console.log(error);
        for (const [key, value] of Object.entries(error.error['data']['errors'])) {
          let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
          let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          this.setMessages([{
            'type': 'danger',
            'message': message['message']
          }]);
        }
      })
  }
}
